import { AreaReportDto } from '@plot/plot-api';

import { BaseEvent } from '@/lib/analytics/trackers/BaseTracker';
import { Any } from '@/lib/analytics/utils';

import {
  WorkspaceTracker,
  WorkspaceTrackerBoundData,
} from './WorkspaceTracker';

export declare interface AreaReportTrackerBoundData
  extends WorkspaceTrackerBoundData {
  areaReport: AreaReportDto;
}

export class AreaReportTracker<
  BoundData extends AreaReportTrackerBoundData = AreaReportTrackerBoundData
> extends WorkspaceTracker<BoundData> {
  track(eventName: string, eventAttributes: BaseEvent) {
    super.track(eventName, {
      areaReportId: this.boundData.areaReport.id,
      ...eventAttributes,
    });
  }

  areaReportViewed() {
    this.track('AreaReportViewed', { trackingEventTrancheNumber: 0 });
  }

  areaReportChartFilterChanged(
    chartName: string,
    filterName: string,
    filterVal: Any,
    activeFilters: string[]
  ) {
    this.track('AreaReportChartFilterChanged', {
      trackingEventTrancheNumber: 0,
      chartName,
      filterName,
      filterVal,
      activeFilters,
    });
  }
}
